import { Observable } from 'rxjs';
export function onComplete(func) {
    return (source$) => new Observable((observer) => source$.subscribe({
        next: (value) => observer.next(value),
        error: (error) => observer.error(error),
        complete: () => {
            func();
            observer.complete();
        },
    }));
}

//# sourceMappingURL=onComplete.js.map
